import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=e1361250&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=e1361250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1361250",
  null
  
)

export default component.exports